import type theme from '#build/ui/form-field'
import type { DeepPartial } from '@nuxt/ui'

const formField: DeepPartial<typeof theme> = {
  slots: {
    root: 'w-full flex flex-col gap-2',
    label: 'flex font-bold text-med-deep-navy items-baseline gap-1',
    container: 'relative flex flex-col gap-2 mt-0',
    description: 'text-sm text-med-deep-navy',
    error: 'text-red-600 mt-0',
    hint: 'text-sm text-med-deep-navy',
    help: 'mt-0 text-sm text-med-deep-navy',
  },
  variants: {
    size: {
      md: { root: '' },
    },
    required: {
      true: {
        label: `after:ms-0.5 after:text-red-600 after:content-['*']`,
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
}

export default formField
